import React from 'react'
import team from '../images/team.png'
import './Rules.css'

export default () => (
  <div className="rulesContainer">
    <div className="rulesHeader">
      <h2>Rules</h2>
    </div>
    <ul>
      <li><h3>Mark the square for each engineer goal you manage to complete</h3></li>
      <li><h3>Team engineering goals are marked with <img src={team} alt="" /></h3></li>
      <li><h3>Prizes will be given for blacked-out cards, first 5 students to get to GRACE (5 in a row), and most GRACEs at the end of the workshop!</h3></li>
    </ul>
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Rules.js